import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  step: 0,
  currentLevel: 1,
  refreshTrigger: 0,
};

const dashboardSlice = createSlice({
  name: "adminDashboard",
  initialState,
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload;
    },
    addStep: (state) => {
      state.step += 1;
    },
    resetStep: (state) => {
      state.step = 0;
    },
    setCurrentLevel: (state, action) => {
      state.currentLevel = action.payload;
    },
    triggerRefresh: (state) => {
      state.refreshTrigger += 1;
    },
  },
});

export const { setStep, addStep, resetStep, setCurrentLevel, triggerRefresh } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
